{
  "avalancheSize.label": "Avalanche size",
  "avalancheSize.small": "small",
  "avalancheSize.medium": "medium",
  "avalancheSize.large": "large",
  "avalancheSize.very_large": "very large",
  "avalancheSize.extreme": "extreme",
  "snowpackStability.label": "Snowpack stability",
  "snowpackStability.good": "good",
  "snowpackStability.fair": "fair",
  "snowpackStability.poor": "poor",
  "snowpackStability.very_poor": "very poor",
  "frequency.label": "Frequency",
  "frequency.none": "none",
  "frequency.few": "few",
  "frequency.some": "some",
  "frequency.many": "many",
  "dangerRating.label": "Danger rating",
  "dangerRating.missing": "missing",
  "dangerRating.missing.long": "Missing",
  "dangerRating.no_snow": "no snow",
  "dangerRating.no_snow.long": "No Snow",
  "dangerRating.no_rating": "no rating",
  "dangerRating.no_rating.long": "No Rating",
  "dangerRating.low": "low",
  "dangerRating.low.long": "Danger Level 1 — Low",
  "dangerRating.low.speech": "low avalanche danger, so danger level one",
  "dangerRating.moderate": "moderate",
  "dangerRating.moderate.long": "Danger Level 2 — Moderate",
  "dangerRating.moderate.speech": "moderate avalanche danger, so danger level two",
  "dangerRating.considerable": "considerable",
  "dangerRating.considerable.long": "Danger Level 3 — Considerable",
  "dangerRating.considerable.speech": "considerable avalanche danger, so danger level three",
  "dangerRating.high": "high",
  "dangerRating.high.long": "Danger Level 4 — High",
  "dangerRating.high.speech": "high avalanche danger, so danger level four",
  "dangerRating.very_high": "very high",
  "dangerRating.very_high.long": "Danger Level 5 — Very High",
  "dangerRating.very_high.speech": "very high avalanche danger, so danger level five",
  "avalancheType.label": "Avalanche type",
  "avalancheType.slab": "Slab avalanche",
  "avalancheType.loose": "Loose snow avalanche",
  "avalancheType.glide": "Glide snow avalanche",
  "avalancheProblem.label": "Avalanche Problem",
  "avalancheProblem.coreZones.label": "Avalanche Problems with Core Zones",
  "avalancheProblem.new_snow": "New snow",
  "avalancheProblem.wind_slab": "Wind slab",
  "avalancheProblem.persistent_weak_layers": "Persistent weak layer",
  "avalancheProblem.wet_snow": "Wet snow",
  "avalancheProblem.gliding_snow": "Gliding snow",
  "avalancheProblem.favourable_situation": "Favourable situation",
  "avalancheProblem.cornices": "Cornices",
  "avalancheProblem.no_distinct_avalanche_problem": "No distinct avalanche problem",
  "avalancheProblem.new_snow.speech": "a new snow problem",
  "avalancheProblem.wind_slab.speech": "a wind slab problem",
  "avalancheProblem.persistent_weak_layers.speech": "a persistent weak layer problem",
  "avalancheProblem.wet_snow.speech": "a wet snow problem",
  "avalancheProblem.gliding_snow.speech": "a gliding snow problem",
  "avalancheProblem.favourable_situation.speech": "a favourable situation",
  "avalancheProblem.cornices.speech": "a cornices problem ",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "no distinct avalanche problem",
  "dangerPattern.label": "Danger patterns",
  "dangerPattern.dp1": "dp.1: deep persistent weak layer",
  "dangerPattern.dp2": "dp.2: gliding snow",
  "dangerPattern.dp3": "dp.3: rain",
  "dangerPattern.dp4": "dp.4: cold following warm / warm following cold",
  "dangerPattern.dp5": "dp.5: snowfall after a long period of cold",
  "dangerPattern.dp6": "dp.6: cold, loose snow and wind",
  "dangerPattern.dp7": "dp.7: snow-poor zones in snow-rich surrounding",
  "dangerPattern.dp8": "dp.8: surface hoar blanketed with snow",
  "dangerPattern.dp9": "dp.9: graupel blanketed with snow",
  "dangerPattern.dp10": "dp.10: springtime scenario",
  "aspect.N": "North",
  "aspect.NE": "North-East",
  "aspect.E": "East",
  "aspect.SE": "South-East",
  "aspect.S": "South",
  "aspect.SW": "South-West",
  "aspect.W": "West",
  "aspect.NW": "North-West",
  "tendency.label": "Tendency",
  "tendency.progression.label": "Development of avalanche danger",
  "tendency.decreasing": "Tendency: Decreasing avalanche danger",
  "tendency.steady": "Tendency: Constant avalanche danger",
  "tendency.increasing": "Tendency: Increasing avalanche danger",
  "validTimePeriod.all_day": "all day",
  "validTimePeriod.all_day.long": "all day",
  "validTimePeriod.earlier": "earlier",
  "validTimePeriod.earlier.long": "earlier in the day",
  "validTimePeriod.later": "later",
  "validTimePeriod.later.long": "later in the day",
  "elevation.treeline.capitalized": "Treeline",
  "elevation.treeline": "treeline",
  "elevation.all": "All elevations",
  "elevation.below": "Below {0}",
  "elevation.above": "Above {0}",
  "elevation.band": "Between {0} and {1}",
  "synopsis.label": "Weather",
  "snowpack.label": "Snowpack",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Avalanche Forecast"
}
